var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4759 11.7071C9.18016 11.8891 9 12.2115 9 12.5588V21C9 21.5523 9.44772 22 10 22H13V18.5C13 17.1193 14.1193 16 15.5 16C16.8807 16 18 17.1193 18 18.5V22H21C21.5523 22 22 21.5523 22 21V12.5588C22 12.2115 21.8198 11.8891 21.5241 11.7071L16.5482 8.64507C15.9054 8.2495 15.0946 8.2495 14.4518 8.64507L9.4759 11.7071Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64888 4.75659C2.25857 4.90296 2 5.27608 2 5.69292V19.9999C2 21.1045 2.89543 21.9999 4 21.9999H7.70801C7.57422 21.6937 7.5 21.3555 7.5 20.9999V12.5587C7.5 11.6906 7.95039 10.8846 8.68976 10.4296L10 9.6233V3.44292C10 2.74472 9.30263 2.26144 8.64888 2.50659L2.64888 4.75659Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt3);
export default __webpack_public_path__ + "static/media/apartments-alt-3.ddc9e02f10813ce03a57fcaedb0eed99.svg";
export { ForwardRef as ReactComponent };